/**
 * Presentation helpers for formatting domain values for display.
 */

/**
 * Format an integer-cents amount as a whole-dollar USD string.
 * Whole-dollar amounts drop the cents (e.g. 100000 -> "$1,000"); amounts with
 * a fractional dollar keep two decimals (e.g. 26550 -> "$265.50").
 */
export function formatUsd(cents: number): string {
  const dollars = cents / 100;
  const hasCents = cents % 100 !== 0;
  return dollars.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0,
  });
}
